'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _functional = require('../utils/functional');

var _listeners = require('../utils/listeners');

var _reactiveState = require('../utils/reactive-state');

var classes = {
  container: 'js-MobileNav',
  items: 'js-MobileNav_Items',
  item: 'js-MobileNav_Item',
  trigger: 'js-MobileNav_Trigger',
  drawer: 'js-MobileNav_Drawer',
  back: 'js-MobileNav_Back'
};

var listeners = new _listeners.Listeners();
var state = new _reactiveState.ReactiveState({
  hasChildrenOpen: false
});
var activeAttribute = 'data-has-child-open';

function init(_ref) {
  var el = _ref.el;

  var scroller = el.closest('.drw-Drawer_Inner');
  state.subscribe('hasChildrenOpen', handleHasChildrenOpen);

  listeners.add(el, 'click', handleTriggerClick);
  listeners.add(el, 'click', handleBackClick);

  function handleHasChildrenOpen(val) {
    scroller.classList.toggle('drw-Drawer_Inner-noScroll', val);
  }

  window.closeAllMobileNavDrawers = function () {
    state.hasChildrenOpen = false;

    var activeItems = (0, _functional.getElements)('.' + classes.item + '[aria-selected=\'true\']');
    activeItems.forEach(function (el) {
      return el.setAttribute('aria-selected', 'false');
    });

    var overflowedDrawers = (0, _functional.getElements)('.' + classes.drawer + '[' + activeAttribute + ']');
    overflowedDrawers.forEach(function (el) {
      return el.removeAttribute(activeAttribute);
    });
  };
}

function handleTriggerClick(_ref2) {
  var target = _ref2.target;

  var trigger = target.closest('.' + classes.trigger);
  if (!trigger) return;

  var parentItem = getParentItem(trigger);
  var parentDrawer = getParentDrawer(trigger);

  parentItem.setAttribute('aria-selected', 'true');

  if (parentDrawer) {
    parentDrawer.setAttribute(activeAttribute, '');
  }

  state.hasChildrenOpen = true;
}

function handleBackClick(_ref3) {
  var target = _ref3.target;

  var back = target.closest('.' + classes.back);
  if (!back) return;

  var parentItem = getParentItem(back);
  var parentDrawer = getParentDrawer(parentItem);

  parentItem.setAttribute('aria-selected', 'false');

  if (parentDrawer) {
    parentDrawer.removeAttribute(activeAttribute);
  }

  state.hasChildrenOpen = false;
}

function getParentItem(el) {
  return el.closest('.' + classes.item);
}

function getParentDrawer(el) {
  return el.closest('.' + classes.drawer);
}